import React from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import type { NavigationItem } from '@atlassian/jira-navigation-types/src/types.tsx';
import EditModal from '../../../edit-shortcut-modal/view/index.tsx';

type Props = {
	baseUrl: string;
	projectKey: string;
	editOrDeleteItemCompleted: (arg1: { item: NavigationItem | undefined; deleted: boolean }) => void;
	items: NavigationItem[];
	editOrDeleteItem: string | undefined;
	editButtonRef: React.RefObject<HTMLButtonElement> | undefined;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => {
	const showModal = Boolean(props.editOrDeleteItem);
	const item =
		props.items.length > 0
			? props.items.filter((existingItem) => existingItem.id === props.editOrDeleteItem)[0]
			: undefined;

	return (
		<ModalTransition>
			{showModal && item ? (
				<EditModal
					baseUrl={props.baseUrl}
					projectId={props.projectKey}
					item={item}
					onCompleted={props.editOrDeleteItemCompleted}
					editButtonRef={props.editButtonRef}
				/>
			) : null}
		</ModalTransition>
	);
};
